var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/internal/OnsiteMessageEventingHooks/EmptyOnsiteMessage.jsx";

import React from 'react';
import { onsiteMessageEventPropTypes, defaultOnsiteMessageEventPropTypes } from './OnsiteMessageEventingTypes';
import { useOnsiteMessagingImpressionEvent } from './useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from './useOnsiteMessagingIntentToShowEvent';

var EmptyOnsiteMessage = function EmptyOnsiteMessage(_ref) {
  var eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      gaEventData = _ref.gaEventData;
  var ref = useOnsiteMessagingImpressionEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    gaEventData: gaEventData
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 12
    }
  });
};

EmptyOnsiteMessage.propTypes = process.env.NODE_ENV !== "production" ? onsiteMessageEventPropTypes : {};
EmptyOnsiteMessage.defaultProps = defaultOnsiteMessageEventPropTypes;
/** @component styled-guidist */

export default EmptyOnsiteMessage;
export { EmptyOnsiteMessage };